import { FC, useMemo } from "react"
import classNames from "classnames"
import { TestId } from "@/constants/globals"
import { AlertVariant, TypefaceVariant } from "@/types/alert"
import "./index.scss"

export enum NumberBadgeVariant {
   DEFAULT = "default",
   SMALL = "sm",
}

interface NumberBadgeProps {
   alertVariant?: keyof typeof AlertVariant
   number: number
   typefaceColor?: keyof typeof TypefaceVariant
   size?: NumberBadgeVariant.SMALL
}

const NumberBadge: FC<NumberBadgeProps> = ({
   number,
   alertVariant,
   typefaceColor,
   size,
}) => {
   const badgeVariantClassName = useMemo(() => {
      if (!alertVariant) {
         return ""
      }
      return `--${AlertVariant[alertVariant as keyof typeof AlertVariant]}`
   }, [alertVariant])

   const typefaceClassName = useMemo(() => {
      return `number-badge--${TypefaceVariant[typefaceColor as keyof typeof TypefaceVariant]}`
   }, [typefaceColor])

   return (
      <span
         className={classNames("number-badge", {
            [`number-badge${badgeVariantClassName}`]: badgeVariantClassName,
            [typefaceClassName]: typefaceColor,
            "number-badge--small": size === NumberBadgeVariant.SMALL,
         })}
         data-testid={TestId.NUMBER_BADGE}
      >
         {number}
      </span>
   )
}

export default NumberBadge
